/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoricalTrainingStatisticsResult } from '../../models/historical-training-statistics-result';

export interface DashboardHistoricalTrainingStatisticsGet$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardHistoricalTrainingStatisticsGet(http: HttpClient, rootUrl: string, params?: DashboardHistoricalTrainingStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoricalTrainingStatisticsResult>>> {
  const rb = new RequestBuilder(rootUrl, dashboardHistoricalTrainingStatisticsGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HistoricalTrainingStatisticsResult>>;
    })
  );
}

dashboardHistoricalTrainingStatisticsGet.PATH = '/Dashboard/historical-training-statistics';
